export default "__VITE_ASSET__BB6G$N4d__"